import { render, staticRenderFns } from "./Handwriting.vue?vue&type=template&id=4fae9090&functional=true"
import script from "./Handwriting.vue?vue&type=script&lang=js"
export * from "./Handwriting.vue?vue&type=script&lang=js"
import style0 from "./Handwriting.vue?vue&type=style&index=0&id=4fae9090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports